import { render, staticRenderFns } from "./CollegeAllDepartmentTestReports.vue?vue&type=template&id=b4dfed32"
import script from "./CollegeAllDepartmentTestReports.vue?vue&type=script&lang=js"
export * from "./CollegeAllDepartmentTestReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports